// Copyright (c) 2022 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import BaseMachineItem from './base-machine-item';
import {FormattedMessage} from 'react-intl';
import Implements from '@deere/cps-it.warranty-model-factory/lib/implements';

const baseMachinePanel = props => {

    const baseMachinePanelTitle = (
        <div>
            <FormattedMessage id='BASE_MACHINE_IMPLEMENTS'/>
        </div>
    );

    const baseMachinePanelBody = (
        <div>
            <BaseMachineItem
                actions={props.actions}
                baseMachineComponents={props.baseMachineComponents}
                baseMachinePurchaseOrder={props.baseMachinePurchaseOrder}
                isSubmitButtonDisabled={props.isSubmitDisabled}
                onInputChange={props.onInputChange}
                onInputChangeValue={props.onInputChangeValue}
            />

            <footer>
                <section>
                    <div className='button-group'>
                        <button
                            onClick={props.onCancelImplements}
                        >
                            <FormattedMessage id='CANCEL'/>
                        </button>
                        <button
                            className='primary'
                            disabled={props.isSubmitDisabled}
                            onClick={props.onSubmitImplements}
                        >
                            <FormattedMessage id='SUBMIT'/>
                        </button>
                    </div>
                </section>
            </footer>
        </div>
    );

    return (

        <Accordion
            accordionId='base-machine-panel-accordion'
            body={baseMachinePanelBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={baseMachinePanelTitle}
        />

    );

};

baseMachinePanel.displayName = 'baseMachinePanel';
baseMachinePanel.propTypes = {
    actions: PropTypes.object.isRequired,
    baseMachineComponents: PropTypes.instanceOf(Implements).isRequired,
    baseMachinePurchaseOrder: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    isSubmitDisabled: PropTypes.bool.isRequired,
    onCancelImplements: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onInputChangeValue: PropTypes.func.isRequired,
    onSubmitImplements: PropTypes.func.isRequired
};

export default baseMachinePanel;



// WEBPACK FOOTER //
// ./src/product/details/components/base-machine-panel.js